import React from 'react';
import { FiMenu } from 'react-icons/fi';
import Icon, { IconProps } from '../Icon';

export interface BurgerIconProps extends IconProps {}

const BurgerIcon: React.FC<BurgerIconProps> = ({ ...props }) => {
  return <Icon as={FiMenu} {...props} />;
};

export default BurgerIcon;
